import { render, staticRenderFns } from "./MachineServiceSignalsShow.vue?vue&type=template&id=6a8edc7f&scoped=true&"
import script from "./MachineServiceSignalsShow.vue?vue&type=script&lang=js&"
export * from "./MachineServiceSignalsShow.vue?vue&type=script&lang=js&"
import style0 from "./MachineServiceSignalsShow.vue?vue&type=style&index=0&id=6a8edc7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8edc7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VSkeletonLoader})
